module.exports = __webpack_public_path__ + "img/quming.946814aa.png";